export default __webpack_public_path__ + "static/media/face_2_37.36c223dd.png";